window.onSubmit = function(token) {
  var form = $('.ajaxForm');
  var data = form.serialize();
  // console.log(data);
  if ($('#g-recaptcha-response').val() !== '') {
    $.ajax({
      type: 'post',
      url: window.location.href,
      dataType: 'json',
      data: data,
      beforeSend: function(response) {
        form.find('button[type=submit]').prop('disabled', true);
      },
      success: function(response) {
        console.log(response);
        if (response.success) {
        console.log('success');
        // -- Display notifications --
        $('.form__notifications .success').delay(400).fadeIn();
        setTimeout(function(){
          form[0].reset();
        }, 400);

        } else {
        console.log('error');
        // -- Display notifications --
        $('.form__notifications .error').delay(400).fadeIn();
        }
      },
      error: function(response) {
        console.log('error');
        console.log(response);
        // -- Display notifications --
        $('.form__notifications .error').delay(400).fadeIn();
      },
      complete: function(response) {
        form.find('button[type=submit]').prop('disabled', false);
      }
    });
  }
};



$(document).ready(function(){

  // -- (un)check all --
  $(':checkbox').on('change', function(){
    var checkedTotal = $(this).parents('.dropdown__menu').find('.input:checked').length;
    var total = $(this).parents('.dropdown__menu').find('.input').length;
    if (checkedTotal < total) {
      $(this).parents('.dropdown__menu').find('.input_check_all').prop('checked', false);
    } else {
      $(this).parents('.dropdown__menu').find('.input_check_all').prop('checked', true);
    }
    if ($(this).hasClass('input_check_all')) {
      if ($(this).is(':checked')) {
        $(this).parents('.dropdown__menu').find(':checkbox').prop('checked', false);
      } else {
        $(this).parents('.dropdown__menu').find(':checkbox').prop('checked', true);
      }      
    }
  });


  // -- submit filters form --
  $('.filtersForm').on('submit', function(e){
    e.preventDefault();
    
    const categories = [];
    const audience = [];
    
    // -- get active filters --
    $('[name="categories"]:checkbox:checked').each(function(i){
      categories[i] = $(this).val();
    });
    const categoriesParams = '?categories='+categories.toString();
    var urlParams = `${categoriesParams}`;

    if ($('[name="audience"]').length) {
      $('[name="audience"]:checkbox:checked').each(function(i){
        audience[i] = $(this).val();
      });
      const audienceParams = '&audience='+audience.toString();
      var urlParams = `${categoriesParams}${audienceParams}`;
    }

    // -- update filters and reload page --
    window.history.replaceState({}, '', `${location.pathname}${urlParams}`);
    location.reload();

  });


  // -- reset filter form --
  $('button[type="reset"]').on('click', function(){
    window.location.href = $(this).parents('form').attr('action');
  });

});